import React from 'react';
import {SectionDetail, Tabs, Tab, TabPanel, RaymanUser, Button} from 'components/core';
import {Grid} from '@material-ui/core';
import {OperationsCtx, OperationFilesCtx, OperationFilesProvider} from 'components/dataProviders/operations';
import {UsersCtx} from 'components/dataProviders/users';
import Singletons from 'controllers/Singletons';
import {Phone, Videocam, Archive, Unarchive} from '@material-ui/icons';
import {makeStyles} from '@material-ui/core/styles';
import Chat from './chat';
import FilesList from 'components/files/FilesList';
import { CallInfoCtx } from 'components/dataProviders/callInfo';

const btnStyle = makeStyles((theme) => ({
  root: {
    textTransform: 'none',
    borderRadius: 8,
    padding: 10,
    height: 40,
    boxSizing: 'border-box'
  },
}), {name: "RaymanButton"});


export default function OperationPanel({operationID, onClose = () => {}})
{
    const [selectedTab, setSelectedTab] = React.useState(0);
    const opsCtx = React.useContext(OperationsCtx);
    const usersCtx = React.useContext(UsersCtx);
    const callCtx = React.useContext(CallInfoCtx);
    const handleClose = () => {
        onClose();
    }

    function startCall(webcam)
    {
      callCtx.funcs.call(webcam, operationID);
    }

    function archive()
    {
      opsCtx.funcs.disable(operationID);
    }

    function unarchive()
    {
      opsCtx.funcs.enable(operationID);
    }

    if(!operationID || usersCtx.loading) return null;

    const detailTabs = <Tabs value={selectedTab} onChange={(evt, index) => setSelectedTab(index)} textColor="primary" indicatorColor="primary">
        <Tab label="Chat"/>
        <Tab label="Archivos"/>
    </Tabs>

    const operation = opsCtx.data.indexed[operationID];

    const users = {
      expert: usersCtx.data.indexed[operation.profiles.experts],
      operator: usersCtx.data.indexed[operation.profiles.operators]
    }

    const readonly = operation.currentUserRole === 'admin' || operation.closed;

    let headerUser = {id: users.expert.userID, role: "Experto"};

    if(headerUser.id === Singletons.currentUser.userID)
    {
      headerUser = {id: users.operator.userID, role: "Operario"};
    }

    const archiveBtnVisible = Singletons.userProfiles.admin || Singletons.userProfiles.expert;
    const archiveBtnDisabled = operation.currentUserRole === "operator" && !Singletons.userProfiles.admin;

    const header = <Grid container direction="row" spacing={2} justify="space-between">
      <Grid item><RaymanUser userID={headerUser.id} size={40} label={headerUser.role} /></Grid>
      <Grid item><Grid container direction="row" spacing={1}>
        <Grid item><Button color="secondary" fullWidth={false} disabled={operation.closed || operation.currentUserRole === "admin" || callCtx.info.inCall} onClick={()=>startCall(false)}><Phone /></Button></Grid>
        <Grid item><Button color="secondary" fullWidth={false} disabled={operation.closed || operation.currentUserRole === "admin" || callCtx.info.inCall} onClick={()=>startCall(true)}><Videocam /></Button></Grid>
        {!operation.closed && archiveBtnVisible && <Grid item><Button color="error" disabled={archiveBtnDisabled} fullWidth={false} onClick={()=>archive()}><Archive /></Button></Grid> }
        {operation.closed && archiveBtnVisible && <Grid item><Button color="secondary" disabled={archiveBtnDisabled} fullWidth={false} onClick={()=>unarchive()}><Unarchive /></Button></Grid> }
      </Grid></Grid>
    </Grid>

    return <SectionDetail onCloseClick={() => handleClose()} tabs={detailTabs} header={header} >
    <TabPanel value={selectedTab} index={0}>
        <Chat operationID={operationID} readonly={readonly} operationUserProfiles={operation.profiles}/>
      </TabPanel>
      <TabPanel value={selectedTab} index={1}>
        <OperationFilesProvider operationID={operationID}>
          <FilesList context={OperationFilesCtx} editable/>
        </OperationFilesProvider>
      </TabPanel>
  </SectionDetail>
}